.vc-hideAttachments-accessory {
    color: var(--text-muted);
    margin-top: 0.5em;
    font-style: italic;
    font-weight: 400;
}

.vc-hideAttachments-no-content {
    margin-top: 0;
}
